import {MutationEducationSessionFinishScenarioArgs, Scalars} from "../../../schema";
import {scenarioFinishMutation} from "../graphql";
import {getCurrentAction, getMaxLevel} from "../selectors";
import {PlayerReduxDispatch, PlayerReduxState} from "../types";

export const finishScenarios =
  (prevState: PlayerReduxState) => async (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();

    const {finishedScenarios, client} = state;

    if (finishedScenarios.length === 0) return;

    const scenariosToSend = [...finishedScenarios];
    dispatch({type: "resetFinishScenarios"});

    try {
      const result = await client.mutate<{ok: Scalars["Boolean"]}, MutationEducationSessionFinishScenarioArgs>({
        mutation: scenarioFinishMutation,
        variables: {
          actionId: getCurrentAction(state)?.id,
          level: Math.min(getMaxLevel(prevState), prevState.level),
          scenarioIds: scenariosToSend,
          sessionId: state.sessionId!,
        },
      });

      if (!result?.data?.ok) {
        throw new Error("Cannot finish scenario");
      }
    } catch (error) {
      throw new Error("Cannot finish scenario");
    }
  };
